"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseNiftoryClient = void 0;
const environments_1 = require("../config/environments");
const urql_1 = require("urql");
class BaseNiftoryClient {
    constructor(params) {
        this.params = params;
        this.environment = environments_1.ENVIRONMENTS[params.environmentName];
        if (!this.environment) {
            throw new Error("Invalid environment provided. Must be one of testnet or mainnet");
        }
    }
    /**
     * Executes a graphql mutation.
     * @hidden
     */
    async executeMutation(document, variables, invalidateQueries) {
        const request = (0, urql_1.createRequest)(document, variables);
        const response = await this.graphqlClient.executeMutation(request, {
            requestPolicy: "network-only",
            additionalTypenames: invalidateQueries !== null && invalidateQueries !== void 0 ? invalidateQueries : [],
        });
        if (response.error) {
            throw response.error;
        }
        return response.data;
    }
    /**
     * Executes a graphql query.
     * @hidden
     */
    async executeQuery(document, variables = undefined) {
        const request = (0, urql_1.createRequest)(document, variables);
        const response = await this.graphqlClient.executeQuery(request, {
            requestPolicy: "network-only",
        });
        if (response.error) {
            throw response.error;
        }
        return response.data;
    }
    /**
     * @returns the internal urql graphql client
     * @hidden
     */
    getGraphqlClient() {
        return this.graphqlClient;
    }
    /**
     * Get Current appid being used by the SDK
     * @hidden
     */
    getAppId() {
        return this.params.appId;
    }
    /**
     * Get Current environment being used by the SDK
     * @hidden
     */
    getEnvironment() {
        return this.environment;
    }
    /**
     * Get Current params being used by the SDK
     * @hidden
     */
    getParams() {
        return this.params;
    }
    /**
     * Checks if token or client secret has been initialized yet
     */
    get isReady() {
        return !!(this.params.authToken || this.params.clientSecret);
    }
}
exports.BaseNiftoryClient = BaseNiftoryClient;
